<template>
  <div class="list-wrap">
    <Detail @close="showDialog = false" @refresh="start" v-show="showDialog" :data="detail"></Detail>
    <div v-show="showDel" class="del-wrap fixed">
      <div class="inner">
        <span>提示</span>
        <span class="tc w100">确定删除该条数据吗？请谨慎操作</span>
        <div>
          <span class="btn" @click="toDel">确定</span>
          <span class="btn" @click="cancel">取消</span>
        </div>
      </div>
    </div>
    <div class="option">
      <input type="text" v-model.trim="value" placeholder="请输入姓名" @input="search(value)">
      <span class="btn" @click="addItem">新增</span>
    </div>
    <ListItem :isHead="true" :data="headOption"></ListItem>
    <ListItem 
      v-for="(item, index) in list" 
      :key="index" 
      :data="item" 
      :home="true"
      @onClick="clickItem($event, index)">
    </ListItem>
  </div>
</template>

<script>
import ListItem from '@/components/ListItem.vue';
import Detail from '@/components/Detail.vue';
import { getStorage, setStorage } from '@/utils/index';

export default {
  name: 'List',
  components: {
    ListItem,
    Detail
  },
  data: function () {
    return {
      showDialog: false,
      showDel: false,
      currentDelItem: {},
      detail: {
      },
      value: '',
      headOption: {
        name: '姓名',   // 姓名
        address: '地址',    // 地址
        phone: '电话',  // 电话
        totalPrice: '总价', // 总价
        sended: '已送出',
        operate: '操作'
      },
      list: []
    }
  },
  mounted() {
    this.start();
  },
  methods: {
    start() {
      getStorage().then(res => {
        this.list = res;
      });
    },
    clickItem(type, index) {
      this.currentDelItem = this.list[index];
      if(type == 'edit') {
        this.detail = this.list[index];
        this.showDialog = true;
      } else {
        this.showDel = true;
      }
    },
    search(val) {
      getStorage().then(res => {
        if(!val) {
          this.list = res;
          return;
        }
        this.list = res.filter(item => {
          return item.name.match(val);
        });
      })
    },
    addItem() {
      this.detail = {};
      this.showDialog = true;
    },
    cancel() {
      this.showDel = false;
    },
    toDel() {
      this.list = this.list.filter(item => {
        return item != this.currentDelItem;
      });
      setStorage(this.list);
      this.start();
      this.cancel();
    }
  }
}
</script>

<style>
.tc {
  text-align: center;
}
.option {
  width: 100%;
  display: flex;
  align-items: center;
  height: 60px;
}
input {
  height: 32px;
  padding: 0 10px;
  border: 1px solid #eee;
  margin: 0 30px;
}
.w100 {
  width: 100%;
}
.list-wrap {
  width: 100%;
}
.btn {
  cursor: pointer;
  height: 32px;
  line-height: 32px;
  color: #fff;
  padding: 0 10px;
  background: #51a9dc;
  border-radius: 5px;
}
.fixed {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  background: rgba(0, 0, 0, .5);
}
.del-wrap .inner {
  width: 300px;
  height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
  padding: 20px;
}
.del-wrap .inner .btn {
  margin-top: 50px;
  width: 71px;
  text-align: center;
}
.del-wrap .inner .tc {
  margin-top: 30px;
}
.del-wrap .inner div {
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 0 15px;
  align-items: center;
  justify-content: space-between;
}
</style>